import type { CompanyAddressRow } from "@/hooks/queries/useCompany";

/** First default address, else first saved company address. */
export function pickDefaultCompanyAddress(
  rows: CompanyAddressRow[] | undefined,
): string | null {
  if (!rows?.length) return null;
  const def = rows.find((r) => r.is_default && r.address?.trim());
  if (def?.address) return def.address.trim();
  const first = rows.find((r) => r.address?.trim());
  return first?.address?.trim() ?? null;
}
